define(['text!./templates/quick-quote-link.html'], (templateStr) => {
    return [()=> {
        return {
            replace: true,
            restrict: 'A',
            template: templateStr
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/integration/quoteandbind/quickquote/directives/QuickQuoteLink.js
 **/